import "./progressBar.css";

const ProgressBar = ({ segments }) => {
  if (!Array.isArray(segments)) {
    console.error("segments prop must be an array");
    return null;
  }

  const totalValue = segments.reduce((total, segment) => total + segment.now, 0);

  return (
    <div className="stacked-progress-bar-container">
      {segments.map((segment, index) => {
        const widthPercentage = (segment.now / totalValue) * 100;
        return (
          <div
            key={index}
            className={`stacked-progress-bar ${segment.striped ? "striped" : ""}`}
            style={{ width: `${widthPercentage}%`, backgroundColor: segment.color }}
          ></div>
        );
      })}
    </div>
  );
};

export default ProgressBar;
